export const DefaultLineHeight = '30px';
export const DefaultGapDesktop = '15px';
export const DefaultGapMobile = '10px';
export const DefaultFontFamily = 'Poppins';
export const DefaultFontUrl =
  'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap';
export const DefaultLetterSpacing = '2px';

export const DefaultStyles = {
  letterSpacing: DefaultLetterSpacing,
  fontFamily: DefaultFontFamily,
};

export const ContentWrapperDefaultStylesDesktop = {
  display: 'flex',
  flexDirection: 'column',
  gap: DefaultGapDesktop,
};

export const ContentWrapperDefaultStylesMobile = {
  display: 'flex',
  flexDirection: 'column',
  gap: DefaultGapMobile,
};

export const DefaultElementStyles = {
  HeaderDefaultStyles: {
    fontSize: '52px',
    fontWeight: '600',
    lineHeight: '70px',
    color: '#ffffff',
    ...DefaultStyles,
  },
  SubheadingDefaultStyles: {
    fontSize: '24px',
    fontWeight: '500',
    lineHeight: '35px',
    color: '#ffffff',
    ...DefaultStyles,
  },
  ParagraphDefaultStyles: {
    fontSize: '20px',
    fontWeight: '400',
    color: '#ffffff',
    lineHeight: DefaultLineHeight,
    ...DefaultStyles,
  },
  ButtonDefaultStyles: {
    fontSize: '18px',
    fontWeight: '400',
    padding: '12px 24px',
    wordWrap: 'break-word',
    display: 'inline-block',
    border: '1px solid',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    lineHeight: DefaultLineHeight,
    ...DefaultStyles,
  },
};
